import QTable from 'quasar/src/components/table/QTable.js';

export function getTicketColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'id',
      field: 'id',
      label: 'شماره',
      align: 'center'
    },
    {
      name: 'title',
      field: 'title',
      label: 'عنوان',
      align: 'left',
      style: 'max-width:300px;'
    },
    {
      name: 'department',
      field: 'department',
      label: 'دپارتمان',
      align: 'center'
    },
    {
      name: 'user',
      field: 'user',
      label: 'کاربر',
      align: 'center',
      style: 'max-width:120px;'
    },
    {
      name: 'status',
      field: 'status',
      label: 'وضعیت',
      align: 'center'
    },
    {
      name: 'last_answer_date',
      field: 'last_answer_date',
      label: 'آخرین پاسخ',
      align: 'center'
    },
    {
      name: 'last_answer_user',
      field: 'last_answer_user',
      label: 'پشتیبان',
      align: 'center',
      style: 'max-width:120px;'
    },
    {
      name: 'actions',
      field: 'actions',
      label: '',
      align: 'left'
    }]
}

const bannedColumns = ['user', 'last_answer_user']

export const getTicketTableColumns = (): QTable['columns'] => getTicketColumnsInAdmin()
  .filter(column => !bannedColumns.includes(column.name))
